import SVG15Year from '../svg/SVG15Year';
import { useState } from 'react';
import { useGlobal } from '@/utils/useGlobal';
import Subtract from '../svg/Subtract';
import styles from './index.module.scss';
import { zhCnOrderLink } from '../..';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design/base/eco-img';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('PowerOcean.A');
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const handleVideoPlay = () => {
        setShowEFVideoModal(true);
    };
    const IconSvg = SVG15Year;

    const handleJump = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_banner',
            banner_name: t('title'),
            position: 'banner_1',
            button_name: t('btn2'),
        });
        if (locale === 'cn') {
            window.open(zhCnOrderLink, '_blank');
            return;
        }
    };
    return (
        <div className={`power-ocean-home-A ${styles['power-ocean-home-A']}`}>
            <div className="img-box">
                <EcoImg
                    pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716876142667/pc-tuya.jpg"
                    pad="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716876154016/mo-tuya.jpg"
                    alt={t`EcoFlow PowerOcean Three-phase`}
                />
                <div className="years">
                    <IconSvg />
                </div>
            </div>
            <div className="text-box">
                <h1 className="title">
                    {t('title')}
                    <span className="desc">{t('desc')}</span>
                </h1>
                <div className="btn-box">
                    <div className="video-btn" onClick={handleVideoPlay}>
                        {t('btn1')}
                        <Subtract className="video-icon" />
                    </div>
                    <div className="jump-btn" onClick={handleJump}>
                        {t('btn2')}
                    </div>
                </div>
            </div>
            <EcoDialogVideo
                open={showEFVideoModal}
                src={'https://websiteoss.ecoflow.com/upload/video/1767079088203/homebattery-CN.mp4'}
                callback={() => setShowEFVideoModal(false)}
            />
        </div>
    );
}
